import { render } from "./Bots.vue?vue&type=template&id=5e89003d&scoped=true"
import script from "./Bots.vue?vue&type=script&lang=js"
export * from "./Bots.vue?vue&type=script&lang=js"

import "./Bots.vue?vue&type=style&index=0&id=5e89003d&scoped=true&lang=css"

import exportComponent from "/vercel/path0/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e89003d"]])

export default __exports__